// ArenaBanner.jsx
import React from 'react';
import DebaterTeamInfo from './DebaterTeamInfo';
import DebateInfo from './DebateInfo';
import styles from './ArenaBanner.module.css';


const ArenaBanner = ({ state, currentUser,activeTurn, arena, scores, canStartDebate, debateStatus, onStartDebate }) => {
  
  if(arena?.roles?.debaters.length == undefined) return null;
  const gov = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[0]);
  const opp = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[1]);

  const isWinning = (team) => {
    var team1 =  gov.reduce((total, debater) => total + (scores[debater.uid] || 0), 0);
    var team2 =  opp.reduce((total, debater) => total + (scores[debater.uid] || 0), 0);
    if(arena.custom.teams[0] == team) {
      if(team1 > team2) return true;
    } else if(arena.custom.teams[1] == team) {
      if(team2 > team1) return true;
    }
    return false;
  }
  // Missing fields: speech status and per-user scores are not in sampleData
  //const speakingUids = activeTurn?.activeSpeakers[0].speakerId || []; // TODO: fill in real speaking UIDs
  const speakingUids = activeTurn?.activeSpeakers?.find(s => s.currentSpeaker === true)?.speakerId;

  const speakingTeam = activeTurn?.team;
  //console.log(speakingUids, currentUser?.uid);
  return (
    <div className={`${arena.custom.teams.length < 2 ? styles.bannersingle : styles.banner}`}>

      <DebaterTeamInfo
        teamName={arena.custom.teams[0]}
        debaters={gov}
        speakingUids={speakingUids}
        currentUserUid={currentUser?.uid}
        scores={scores}
        isWinning={isWinning(arena.custom.teams[0])}
        isSingleTeam={arena.custom.teams.length < 2}
        isActive={speakingTeam === arena.custom.teams[0]}
      />
      <DebateInfo state={state} activeTurn={activeTurn} arena={arena} canStartDebate={canStartDebate} debateStatus={debateStatus} onStartDebate={onStartDebate} />
      {arena.custom.teams.length >= 2 && <><DebaterTeamInfo
        teamName={arena.custom.teams[1]}
        debaters={opp}
        speakingUids={speakingUids}
        currentUserUid={currentUser?.uid}
        scores={scores}
        isWinning={isWinning(arena.custom.teams[1])}
        isSingleTeam={arena.custom.teams.length < 2}
        isActive={speakingTeam === arena.custom.teams[1]}
      /></>}
    </div>
  );
};

export default ArenaBanner;
